<template>
  <div class="container">
    <div v-if="user.admin" class="spaced-row">
      <div class="grow"></div>

      <mad-button color="red" @click="deleteForm">
        <mad-icon mdi="close" />Delete form
      </mad-button>
    </div>
    <mad-form @submit.prevent="submit">
      <mad-form-item label="Typeform id">
        <mad-input v-model="form.typeform_id" />
      </mad-form-item>
      <mad-form-item label="Barcode">
        <image-input v-model="form.barcode" />
      </mad-form-item>

      <div class="spaced-row">
        <mad-button @click="clickCancel">
          <mad-icon mdi="close" />Cancel
        </mad-button>
        <div class="grow"></div>
        <mad-button color="brown" type="submit">
          <mad-icon mdi="check" />Update barcode
        </mad-button>
      </div>
    </mad-form>
  </div>
</template>

<script>
import ImageInput from '../inputs/ImageInput'

export default {
  components: {
    ImageInput,
  },

  props: {
    id: { type: String, required: true },
  },

  data: () => ({
    location_id: '',
    form: {
      typeform_id: '',
      barcode: '',
    },
  }),

  computed: {
    user() {
      return this.$store.state.user
    },
  },

  created() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      const form = await this.$store.dispatch('getForm', {
        id: this.id,
      })

      this.form = form
      this.location_id = form.location.id
    },
    async submit() {
      await this.$store.dispatch('updateForm', {
        ...this.form,
        id: this.id,
      })
      this.$router.push(`/locations/${this.location_id}`)
    },
    async deleteForm() {
      await this.$store.dispatch('deleteForm', {
        id: this.id,
      })
      this.$router.push(`/locations/${this.location_id}`)
    },
    clickCancel() {
      this.$router.push(`/locations/${this.location_id}`)
    },
  },
}
</script>

<style>
</style>
